import React, { useState } from "react"
import ReCAPTCHA from "frontend/components/forms/recaptcha"
import { verifyRecaptcha } from "frontend/utils/upload"
import { Heading } from "frontend/components/text"
import t from "frontend/utils/translations"
import styles from "./RecaptchaDisplay.module.css"

const RecaptchaDisplay = ({ onSuccess }) => {
  const [isVerifying, setIsVerifying] = useState(false)
  const [hasError, setHasError] = useState(false)

  const handleCheck = async (string) => {
    setIsVerifying(true)
    try {
      await verifyRecaptcha(string)
    } catch (e) {
      console.warn(e)
      setHasError(true)
      setIsVerifying(false)
      return
    }

    onSuccess()
  }
  return (
    <div className={styles.container}>
      <Heading size={4} className={styles.heading}>
        {t("upload.recaptcha.title")}
      </Heading>
      {hasError && <p>{t("upload.recaptcha.error")}</p>}
      {isVerifying ? (
        <p>{t("upload.recaptcha.verifying")}</p>
      ) : (
        <ReCAPTCHA sitekey={window.upload_config.recaptcha_key} onChange={handleCheck} />
      )}
    </div>
  )
}

export default RecaptchaDisplay
